import InnerComponent from '@Components/Inventory/StockTransfer/ViewStockTransfer';
import orgContainer from '@Components/AppContainer';

const ViewStockTransfer = () => ((orgContainer(InnerComponent)));
export default ViewStockTransfer;
